import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Box } from '@mui/material';
import { POSITION_SLOT_WORKER_TYPE_LABELS } from '../../constants';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee/model';
import PositionProfileLinkField from 'domain/people/positionProfiles/shared/fields/PositionProfileLinkField';
import type { PreviewPositionSlotListItem } from '../../types';
import { DetailField } from 'framework/ViewTypes';
import { buildPositionSlotTitle } from '../../shared/utils/positionSlotTitle';
import WorkerAndPfrCell from '../../shared/fields/WorkerAndPfrCell';

const PositionSlotDetailsCard = ({ positionSlot }: { positionSlot: PreviewPositionSlotListItem }) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 2 }}>
      <DetailField icon={<ApartmentOutlinedIcon />} tooltip="Offices" value={positionSlot.officesLabel} />
      <DetailField
        icon={<CategoryOutlinedIcon />}
        tooltip="Category"
        value={POSITION_SLOT_WORKER_TYPE_LABELS[positionSlot.workerType] || positionSlot.workerType}
      />
      <DetailField
        icon={<PercentOutlinedIcon />}
        tooltip="FTE"
        value={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES[positionSlot.workRateType]}
      />

      <DetailField
        icon={<AccountTreeOutlinedIcon />}
        tooltip="Business function"
        value={positionSlot.businessFunctionLabel}
      />
      <Box sx={{ gridColumn: 'span 2', minWidth: 0 }}>
        <DetailField
          icon={<DescriptionOutlinedIcon />}
          tooltip="Profile"
          value={
            positionSlot.positionProfileId ? (
              <PositionProfileLinkField
                positionProfileId={positionSlot.positionProfileId}
                defaultName={buildPositionSlotTitle(positionSlot)}
              />
            ) : undefined
          }
        />
      </Box>

      <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
        <DetailField
          icon={<PersonOutlineIcon />}
          tooltip="Worker / PFR"
          value={<WorkerAndPfrCell positionSlot={positionSlot} />}
        />
      </Box>
    </Box>
  );
};

export default PositionSlotDetailsCard;
